import React from "react";

export default function Careers() {
  return (
    <div>
      {/* ✅ Hero Banner */}
      <div className="relative h-[300px] md:h-[400px] w-full flex items-center justify-center">
        <img
          src="/images/careers-banner.webp"
          alt="Careers at MAC LABS LTD"
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-black/50"></div>
        <h1 className="relative text-4xl md:text-5xl font-bold text-white text-center">
          Careers at MAC LABS LTD
        </h1>
      </div>

      {/* ✅ Content Section */}
      <div className="animate-fadeIn max-w-7xl mx-auto px-6 py-16 bg-white rounded-xl shadow-md -mt-16 relative z-10">
        
        {/* Intro */}
        <p className="text-gray-700 leading-relaxed mb-8 text-lg">
          At <span className="font-semibold">MAC LABS LTD</span>, we believe that great people build great companies. 
          If you’re passionate about making a difference in healthcare and want to be part of an innovative, 
          future-focused organization, we’d love to hear from you.
        </p>

        {/* Why Work With Us */}
        <h2 className="text-3xl font-bold mb-4 text-gray-900">Why Work With Us</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-10">
          <li><span className="font-semibold">Excellence in Operations –</span> Be part of a company driven by quality, safety, and reliability.</li>
          <li><span className="font-semibold">Professional Growth –</span> Structured training and development programs to support career advancement.</li>
          <li><span className="font-semibold">Commitment to Values –</span> Integrity, responsibility, and respect form the foundation of our work culture.</li>
          <li><span className="font-semibold">Collaborative Culture –</span> We value teamwork, fresh ideas, and an open work environment.</li>
        </ul>

        {/* Explore Opportunities */}
        <h2 className="text-3xl font-bold mb-4 text-gray-900">Explore Opportunities</h2>
        <p className="text-gray-700 mb-4">
          We’re always looking for talented people in areas such as:
        </p>
        <ul className="grid md:grid-cols-2 gap-4 text-gray-700 mb-10">
          <li className="bg-gray-100 p-4 rounded-lg shadow-sm">Research & Development (R&D)</li>
          <li className="bg-gray-100 p-4 rounded-lg shadow-sm">Quality & Regulatory</li>
          <li className="bg-gray-100 p-4 rounded-lg shadow-sm">Manufacturing & Operations</li>
          <li className="bg-gray-100 p-4 rounded-lg shadow-sm">Sales & Marketing</li>
          <li className="bg-gray-100 p-4 rounded-lg shadow-sm">Supply Chain & Support Functions</li>
        </ul>

        {/* Life at MAC LABS */}
        <h2 className="text-3xl font-bold mb-4 text-gray-900">Life at MAC LABS LTD</h2>
        <p className="text-gray-700 leading-relaxed mb-10">
          Our culture is built on trust, inclusivity, and respect. We celebrate achievements, 
          encourage innovation, and support every employee’s journey to success.
        </p>

        {/* Call to Action */}
        <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg shadow-sm">
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">Ready to Build Your Future?</h3>
          <p className="text-gray-700">
            Send us your resume at{" "}
            <a href="mailto:maclabsltd@gmail.com" className="text-blue-600 font-medium hover:underline">
              📩 maclabsltd@gmail.com
            </a>{" "}
            and take the next step in your journey with us.
          </p>
        </div>
      </div>
    </div>
  );
}
